import DOMPurify from "dompurify";
import { emailContentSanitizeConfig } from "./consts";

/** Sanitize HTML from email / draft bodies before dangerouslySetInnerHTML. */
export function sanitizeEmailHtml(html: string): string {
  return DOMPurify.sanitize(html, emailContentSanitizeConfig);
}
